// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { MainSidebar } from '../components/mainsidebar'
import { DynamicSecSidebar } from '../components/dynamicSecSidebar'
import config from '../config/config.json'

export class WorkerProfile extends Component {
    constructor(props) {
        super(props)

        this.init()

        this.state = {
            allModules: {},
            activeProviderId: config.consts.MY_CONTENT_KEY,
            activeProviderName: config.consts.MY_CONTENT,
            activeIndex: 0,
            activeModules: [],
            activeModule: "",
            allResults: [],
            activeResults: [],
            secNavItems: [
                {
                    "title": config.consts.MY_CONTENT,
                    "link": "/trainingContent?id=" + config.consts.MY_CONTENT_KEY,
                    "icon": "#"
                }
            ],
            officialResults: [],
            unofficialResults: []
        }

        this.getWorkerModules(this.props.env)
        this.getWorkerGames(this.props.env)

        this.init = this.init.bind(this)
        this.getWorkerModules = this.getWorkerModules.bind(this)
        this.getWorkerGames = this.getWorkerGames.bind(this)
        this.handleClickedPanelItem = this.handleClickedPanelItem.bind(this)
        this.handleViewPerformance = this.handleViewPerformance.bind(this)
        this.handleViewCertificate = this.handleViewCertificate.bind(this)
        this.disconnectWorker = this.disconnectWorker.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            if (storedData.profileType === 'worker') {
                let data = {
                    profileType: storedData.profileType,
                    loginStatus: storedData.loginStatus,
                    authToken: storedData.authToken,
                    average_strikes: storedData.average_strikes,
                    confirmed: storedData.confirmed,
                    email: storedData.email,
                    gender: storedData.gender,
                    purpose: storedData.purpose,
                    uid: storedData.uid,
                    first_name: storedData.first_name,
                    last_name: storedData.last_name,
                    last_active_at: storedData.last_active_at,
                    workers: JSON.parse(storedData.workers),
                    globalModules: JSON.parse(storedData.globalModules)
                }

                this.props.handleWorkerDataUpdateFromSessionStorage(data)
            }
        }
    }

    getWorkerModules(env) {
        fetch(config[env] + config.api.worker_modules.endpoint, {
            method: config.api.worker_modules.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                let allModules = responseJson.enabler_modules

                // Custom tab to display all earned certificates, even if providers have been disconnected (results should still remain)
                allModules[config.consts.MY_CERT_KEY] = {
                    name: config.consts.MY_CERT,
                    enabler_modules: this.getCompletedModules(allModules)
                }

                let secNavItems = this.prepareSecNavItems(allModules)

                //console.log("All worker modules:")
                //console.log(allModules)

                this.setState({
                    allModules,
                    secNavItems,
                    activeModules: allModules[this.state.activeProviderId].enabler_modules
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    /**
     * Get all modules uniquely in a flat array (no duplicates).
     */
    getModulesFlat(allModules) {
        let modules = []
        let modulesKeyed = {}

        for (const orgKey in allModules) {
            allModules[orgKey].enabler_modules.forEach((module) => {
                modulesKeyed[module.name] = module
            })
        }

        modules = Object.values(modulesKeyed)

        return modules
    }

    /**
     * Get all completed modules uniquely in a flat array (no duplicates).
     */
    getCompletedModules(allModules) {
        let completedModules = []
        let completedModulesKeyed = {}

        for (const orgKey in allModules) {
            allModules[orgKey].enabler_modules.forEach((module) => {
                if (module.completed) {
                    completedModulesKeyed[module.name] = module
                }
            })
        }

        completedModules = Object.values(completedModulesKeyed)

        return completedModules
    }

    getWorkerGames(env) {
        fetch(config[env] + config.api.list_worker_games.endpoint, {
            method: config.api.list_worker_games.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    allResults: responseJson
                })

                //console.log("All worker results:")
                //console.log(this.state.allResults)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    disconnectWorker(providerId, env) {
        console.log(config[env] + config.api.disconnect_provider.endpoint + providerId)
        fetch(config[env] + config.api.disconnect_provider.endpoint + providerId, {
            method: config.api.disconnect_provider.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    activeProviderId: config.consts.MY_CONTENT_KEY,
                    activeProviderName: config.consts.MY_CONTENT,
                    activeIndex: 0
                })
                this.getWorkerModules(env)
                this.getWorkerGames(env)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    prepareSecNavItems(allModules) {
        let secNavItems = [
            {
                "title": config.consts.MY_CONTENT,
                "key": config.consts.MY_CONTENT_KEY,
                "icon": "#"
            }
        ]

        for (let key in allModules) {
            if (key !== config.consts.MY_CONTENT_KEY) {
                secNavItems.push({
                    "title": allModules[key].name,
                    "key": key,
                    "icon": "#"
                })
            }
        }

        return secNavItems
    }

    handleClickedPanelItem(providerId, index, providerName) {
        this.setState(state => {
            return {
                activeIndex: index,
                activeProviderId: providerId,
                activeProviderName: providerName,
                activeModules: state.allModules[providerId].enabler_modules
            }
        })

        this.props.router.push('/individual')
    }

    handleViewPerformance(moduleName) {
        let activeProviderId = this.state.activeProviderId
        let activeResults = []

        if (this.state.activeProviderId === config.consts.MY_CONTENT_KEY) {
            activeResults = this.state.allResults.filter(result => {
                return ((result.provider_id === null) && (result.enabler_module === moduleName))
            })
        }
        else if (this.state.activeProviderId === config.consts.MY_CERT_KEY) {
            activeResults = this.state.allResults.filter(result => {
                return result.enabler_module === moduleName
            })
        }
        else {
            activeResults = this.state.allResults.filter(result => {
                return ((result.provider_id === Number(activeProviderId)) && (result.enabler_module === moduleName))
            })
        }

        this.setState({
            activeModule: moduleName,
            activeResults: activeResults
        })

        this.props.router.push('/individual/results')
    }

    handleViewCertificate(moduleName) {
        this.setState({
            activeModule: moduleName
        })
        this.props.router.push('/individual/certificate')
    }

    render() {
        let childWithProps = React.Children.map(this.props.children, child => {
            return (
                React.cloneElement(child, {
                    appData: this.props.appData,
                    env: this.props.env,
                    activeModules: this.state.activeModules,
                    allResults: this.state.allResults,
                    activeProviderId: this.state.activeProviderId,
                    activeProviderName: this.state.activeProviderName,
                    activeModule: this.state.activeModule,
                    activeResults: this.state.activeResults,
                    handleViewPerformance: this.handleViewPerformance,
                    handleViewCertificate: this.handleViewCertificate,
                    disconnectWorker: this.disconnectWorker
                })
            )
        })

        return (
            <div className="worker-profile-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />

                <DynamicSecSidebar
                    menuItems={this.state.secNavItems}
                    activeIndex={Number(this.state.activeIndex)}
                    handleClickedPanelItem={this.handleClickedPanelItem}
                />

                <div className="main-body">
                    {childWithProps}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/workerProfile.js